import { Component, ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { WalletHandler } from "../wallet/wallet_handler";

// Dodgy cache of last received "isAuthenticated" value from wallet handler
let lastIsAuthenticated: boolean|null = null;

interface AuthenticateState {
    isAuthenticated: boolean|null;
    subscribeIsAuthenticatedId: string|null;
}

export class Authenticate extends Component<any, AuthenticateState> {
    state: AuthenticateState = {
        isAuthenticated: lastIsAuthenticated,
        subscribeIsAuthenticatedId: null,
    };

    public async componentDidMount(): Promise<void> {
        const subscribeIsAuthenticatedId = WalletHandler.getInstance().subscribeIsAuthenticated(async (isAuthenticated) => {
            if (!isAuthenticated) {
                try {
                    await WalletHandler.getInstance().authenticate();
                    const isAuthenticated = await WalletHandler.getInstance().isAuthenticated();
                    lastIsAuthenticated = isAuthenticated;
                    this.setState((state) => ({
                        ...state,
                        isAuthenticated: isAuthenticated,
                    }));
                } catch (error) {
                    lastIsAuthenticated = false;
                    this.setState((state) => ({
                        ...state,
                        isAuthenticated: false,
                    }));
                }
            } else {
                lastIsAuthenticated = isAuthenticated;
                this.setState((state) => ({...state, isAuthenticated: isAuthenticated}));
            }
        });
        this.setState((state) => ({
            ...state,
            subscribeIsAuthenticatedId: subscribeIsAuthenticatedId,
        }));
    }

    public componentWillUnmount(): void {
        if (this.state.subscribeIsAuthenticatedId) {
            WalletHandler.getInstance().unsubscribeIsAuthenticated(this.state.subscribeIsAuthenticatedId);
        }
    }

    public render(): ReactNode {
        // Redirect if not authenticated
        if (this.state.isAuthenticated === false) {
            return <Navigate to="/"/>;
        }

        // TODO: loading overlay
        return <Outlet/>;
    }
}
